import * as CommonTypes from "../types/common.types"
import http from "./http-common"
import { toDayString } from "../utils/dayString"

class AllyServiceClass {
    private token: string | undefined;
    private config: { headers: { Authorization: string | undefined } };
    private seller: string = '/seller'
    private ally: string = '/ally'
    private passenger: string = '/passenger'
    private tours: string = '/tours'
    private trips: string = '/trips'
    private guider: string = '/guider'
    private driver: string = '/driver'
    private reservation: string = '/reservation'
    private group: string = '/group'
    private payment: string = '/payments'
    constructor(token?: string) {
        this.token = token;
        this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }
    
    setToken(token: string) {
      this.token = token;
      this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }

    login(data: CommonTypes.DefaultLogin) {
      return http.post(this.ally + '/login', data)
    }

    listTours(date: string) {
      return http.post(this.tours + '/listToursTripsPassengers', {date}, this.config)
    }

    me() {
      return http.get(this.ally + '/me', this.config)
    }

    createGroup() {
      return http.post(this.group + '/create', {}, this.config)
    }

    createPassenger(data: Partial<CommonTypes.Passenger>) {
      return http.post(this.passenger + '/create', data, this.config)
    }

    getReservation(reservation_id: string) {
      return http.get(this.reservation + `/reservation/${reservation_id}`, this.config)
    }

    // La fecha del tour viaja como 'yyyy-MM-dd' (ver toDayString): un Date se convertiría a hora
    // universal y, desde Europa, el tour quedaba un día antes.
    editReservation(reservation_id: string, data: CommonTypes.Reservation) {
      const body = data.reservation_date ? { ...data, reservation_date: toDayString(data.reservation_date) } : data
      return http.put(this.reservation + `/edit/${reservation_id}`, body, this.config)
    }

    createReservation(data: CommonTypes.SubmitReservation) {
      return http.post(this.reservation + '/create', { ...data, reservation_date: toDayString(data.reservation_date) }, this.config)
    }

    // "Mis reservas" (perfil): reservas con algún tour entre from y to ('yyyy-MM-dd'), completas.
    listMyReservations(from: string, to: string) {
      return http.post(this.ally + '/my-reservations', { from, to }, this.config)
    }

    // Liquidaciones (portal): sus pagos pendientes con abonos y pasajeros, lo no cobrado y los totales.
    listMySettlements() {
      return http.get(this.ally + '/my-settlements', this.config)
    }

    getPassengerPlan(id: string) {
      return http.get(this.passenger + `/passenger-plan?passenger_id=${id}`, this.config)
    }

    deleteReservation(reservation_id: string) {
      return http.delete(this.reservation + `/delete/${reservation_id}`, this.config)
    }

    listPassengers() {
      return http.get(this.passenger + '/ally', this.config)
    }
}

const AllyService = new AllyServiceClass()

export default AllyService